import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { stringToHex, validateUrl } from '~/services/util';
import Logo from './Logo';
import Initial from './Initial';

const Body = ({ initial, name, slug, source, borderColor, borderWidth, upload, icon, defaultImg, isSponsored }) => {
    const navigate = useNavigate();

    const [isImage, setIsImage] = useState(true);
    const isDefault = !name && !source;
    const isIcon = !!icon && !name && !source;
    const isUrl = validateUrl(source);
    const url = isImage ? source : (initial ?? defaultImg);
    const avatarName = name ? name?.split(' ').slice(0, -1).join(' ').charAt(0) + name?.split(' ').slice(-1).join(' ').charAt(0) : '';

    const handleProfile = () => {
        if (slug) navigate(`/${slug}/about`);
    };

    return isSponsored ? (
        <Logo
            src={isIcon ? icon : isDefault ? defaultImg : url}
            borderColor={borderColor}
            borderWidth={borderWidth}
            onError={() => setIsImage(false)}
            onProfile={handleProfile}
            isSponsored={isSponsored}
        />
    ) : (
        <Initial name={avatarName} background={stringToHex(name)} upload={upload} />
    );
};

export default Body;
